import { Button } from "@/components/ui/button";
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from "@/components/ui/empty";
// @ts-expect-error side-effect import
import "@fontsource-variable/nunito-sans";
import type React from "react";
import type { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { isChunkError } from "@/lib/lazyWithRetry";
import { ThemeProvider } from "../ThemeProvider";
import { ReactComponent as ErrorImage } from "./error.svg";
import "./translations";
import { ReactComponent as UpdateImage } from "./update.svg";

const AppError: React.FC<FallbackProps> = ({ error }) => {
	const { t } = useTranslation("appError");
	const isUpdateError = isChunkError(error);
	return (
		<ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
			<div className="w-screen h-screen flex items-center justify-center">
				<Empty className="border-0 p-0">
					<EmptyMedia>
						{isUpdateError ? (
							<UpdateImage style={{ maxHeight: "14rem", width: "auto" }} />
						) : (
							<ErrorImage style={{ maxHeight: "14rem", width: "auto" }} />
						)}
					</EmptyMedia>
					<EmptyContent>
						<EmptyHeader>
							<EmptyTitle>
								{t(isUpdateError ? "updateTitle" : "title")}
							</EmptyTitle>
							<EmptyDescription>
								{t(isUpdateError ? "updateSubtitle" : "subtitle")}
							</EmptyDescription>
						</EmptyHeader>
					</EmptyContent>
					<Button asChild>
						<a href="/">{t("btnReload")}</a>
					</Button>
				</Empty>
			</div>
		</ThemeProvider>
	);
};

export default AppError;
